import { defineStore } from 'pinia';

import { useRootStore } from './root';

import {
  AggregationRepository,
  CampaignAggregationRegisterForm,
} from '@/repositories/generated';
import { CampaignAggregationUiFormSchema } from '@/validations';

type CampaignAggregationStoreState = {
  form?: CampaignAggregationRegisterForm;
};

export const useCampaignAggregationStore = defineStore('campaignAggregation', {
  state: (): CampaignAggregationStoreState => ({
    form: undefined,
  }),
  actions: {
    async aggregate(form: CampaignAggregationUiFormSchema) {
      const rootStore = useRootStore();
      rootStore.isLoading = true;

      this.form = {
        startDateTime: form.startDateTime.toISOString(),
        endDateTime: form.endDateTime.toISOString(),
        criteria: form.criteria,
        filter: {
          companyIds: form.filter.companies.map((value) => value.id),
          shopIds: form.filter.shops.map((value) => value.id),
          campaignIds: form.filter.campaigns.map((value) => value.id),
          walletServiceIds: form.filter.walletServices.map((value) => value.id),
        },
      };

      return AggregationRepository.registerCampaignAggregation({ requestBody: this.form })
        .finally(() => {
          rootStore.isLoading = false;
        });
    },
  },
});
